<!-- header start -->
<header class="sticky fixed" [ngClass]="class" [class.fixed]="stick && sticky">
  <div class="mobile-fix-option"></div>
  <!-- <div class="top-header" *ngIf="topbar"> 
    <div class="container">
      <div class="row">
        <div class="col-lg-6">
          <div class="header-contact">
            <ul>
              <li>Welcome to Our store Multikart</li>
              <li>
                <i class="fa fa-phone" aria-hidden="true"></i>Call Us: 123 - 456
                - 7890
              </li>
            </ul>
          </div>
        </div>
        <div class="col-lg-6 text-right">
          <ul class="header-dropdown">
            <li class="compare">
              <a [routerLink]="['/shop/compare']"
                ><i class="fa fa-random" aria-hidden="true"></i>Compare</a
              >
            </li>
            <li class="mobile-wishlist">
              <a [routerLink]="['/shop/wishlist']"
                ><i class="fa fa-heart" aria-hidden="true"></i>Wishlist</a
              >
            </li>
            <li class="onhover-dropdown mobile-account">
              <i class="fa fa-user" aria-hidden="true"></i> My Account
              <ul class="onhover-show-div">
                <li>
                  <a data-lng="en"> Login </a>
                </li>
                <li>
                  <a data-lng="es"> Logout </a>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div> -->
  <div class="container main-container">
    <div class="row">
      <div class="col-sm-12">
        <div class="main-menu border-section border-top-0">
          <!-- <div class="menu-left">
                        <app-left-menu></app-left-menu>
                    </div> -->
          <div class="brand-logo layout2-logo headerlogo">
            <a [routerLink]="['/']">
              <img [src]="themeIcon" class="img-fluid logo-img web-view freshmartlogo" alt="logo"/>
              <img [src]="themeLogo" class="img-fluid logo-img web-view mobileView" style="width: 160px; padding-left: 10px;"alt="logo" />
            </a>
            <a [routerLink]="['/']">
              <img [src]="themeIcon" class= "mobi-view"/>
            </a>
            <!-- <section class="authentication-page section-b-space">
              <section class="search-block">
                <form class="form-header">
                  <div class="form-group">
                    <input
                      type="text"
                      class="form-control" 
                      id="exampleInputPassword1"
                      placeholder="Search a Product"
                    />
                  </div>
                  <button type="submit" class="btn btn-primary">
                    <i class="fa fa-search"></i>
                  </button>
                </form>
              </section>
            </section> -->

            <!--<app-location
              [isLocation]="isLocation"
              [isLocation2]="isLocation2"
              [isCart]="isCart"
            ></app-location> -->
          </div>
          <form
            class="form_search head-form-search"
            role="form"
            *ngIf="isHomePage"
          >
            <input
              id="query search-autocomplete"
              type="search"
              placeholder="Find the best for your..."
              class="nav-search nav-search-field"
              aria-expanded="true"
            />
            <button type="button" name="nav-submit-button" class="btn-search">
              <i class="ti-search"></i>
            </button>
          </form>
          <!-- <a [routerLink]="['/pages/useraccount']" *ngIf="isLogin"
            >User</a
          > -->

          <div class="menu-right pull-right">
            <app-settings
              *ngIf="loadingAction"
              [isLogin]="isLogin"
              [isCart]="isCart"
              [isLocation]="isLocation"
            ></app-settings>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- <div class="container">
    <div class="row">
      <div class="col-lg-12">
        <div class="main-nav-center">
          <app-menu></app-menu>
        </div>
      </div>
    </div>
  </div> -->
</header>
<!-- header end -->
